import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

const CATEGORY_LABELS = {
  tournament_management: 'إدارة بطولات', refereeing: 'تحكيم',
  photography: 'تصوير', design: 'تصميم', live_streaming: 'بث مباشر',
  private_coaching: 'تدريب خاص', sports_consulting: 'استشارات رياضية',
  event_operations: 'تشغيل فعاليات', video_analysis: 'تحليل فيديو',
  fitness_training: 'تدريب لياقة', nutrition: 'تغذية', other: 'أخرى'
};

const Stars = ({ rating }) => (
  <div className="stars">
    {[1,2,3,4,5].map(s => <span key={s} className={`star ${s <= Math.round(rating) ? 'filled' : ''}`}>★</span>)}
  </div>
);

const ServiceCard = ({ service }) => (
  <Link to={`/services/${service.uuid}`} className="service-card card">
    {service.is_featured && <div className="featured-tag">⭐ مميز</div>}
    <div className="service-cover">
      {service.cover_image ? (
        <img src={service.cover_image} alt={service.title} />
      ) : (
        <div className="service-cover-placeholder">
          <span className="service-icon">⚡</span>
        </div>
      )}
      <div className="service-category-badge">{CATEGORY_LABELS[service.category]}</div>
    </div>
    <div className="service-body">
      <div className="service-provider">
        {service.provider_avatar ? (
          <img src={service.provider_avatar} alt={service.provider_name} className="avatar avatar-sm" />
        ) : (
          <div className="avatar-placeholder avatar-sm" style={{ fontSize: 13 }}>
            {service.provider_name?.[0]}
          </div>
        )}
        <span className="provider-name">{service.provider_name}</span>
        {service.provider_country && <span className="provider-country text-muted text-sm">• {service.provider_country}</span>}
      </div>
      <h3 className="service-title">{service.title}</h3>
      <div className="service-stats">
        <div className="flex gap-8">
          <Stars rating={service.rating || 0} />
          <span className="text-muted text-sm">({service.reviews_count || 0})</span>
        </div>
        <span className="text-muted text-sm">📦 {service.orders_count || 0} طلب</span>
      </div>
    </div>
    <div className="service-footer">
      <span className="service-price">
        يبدأ من <strong>{service.price} {service.price_currency || 'USD'}</strong>
      </span>
      {service.delivery_time && (
        <span className="delivery-time text-muted text-sm">⏱ {service.delivery_time}</span>
      )}
    </div>
  </Link>
);

export default ServiceCard;
